import React from 'react';

interface StepperProps {
  currentStep: number;
}

const CheckIcon = () => (
  <svg width="20" height="16" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.22619 16.1629L2.70709 10.6438C2.4097 10.3464 2.00635 10.1793 1.58578 10.1793C1.1652 10.1793 0.761855 10.3464 0.464464 10.6438C0.167073 10.9412 0 11.3445 0 11.7651C0 11.9733 0.0410177 12.1795 0.120711 12.3719C0.200403 12.5643 0.317211 12.7392 0.464464 12.8864L7.11283 19.5348C7.73313 20.1551 8.73516 20.1551 9.35546 19.5348L26.1831 2.70709C26.4805 2.4097 26.6476 2.00635 26.6476 1.58578C26.6476 1.1652 26.4805 0.761856 26.1831 0.464464C25.8857 0.167073 25.4824 0 25.0618 0C24.6412 0 24.2379 0.167073 23.9405 0.464464L8.22619 16.1629Z"
      fill="white"
    />
  </svg>
);

const Stepper: React.FC<StepperProps> = ({ currentStep }) => {
  const steps = [1, 2, 3, 4];

  return (
    <div className="stepper">
      <ul className="d-flex justify-content-between align-items-center p-0 m-0">
        {steps.map((step, idx) => {
          const isDone = currentStep > step;
          const isActive = currentStep === step;
          const isLineActive = currentStep > step;

          return (
            <React.Fragment key={step}>
              <li className={`text-center step-item ${isDone ? 'done' : isActive ? 'active' : ''}`}>
                <span className="step d-inline-flex align-items-center justify-content-center">
                  {isDone ? <CheckIcon /> : step}
                </span>
              </li>
              {idx < steps.length - 1 && (
                <li className={`line-item ${isLineActive ? 'active' : ''}`}>
                  <span className="border-line"></span>
                </li>
              )}
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};

export default Stepper;
